<template>
    <span
        class="text-danger float-left mr-1"
        v-if="convenio.idSituacaoConvenio != 9"
    >
        <i
            class="fa fa-trash fa-lg icon-button"
            title="Excluir Comprometimento"
            @click.stop="confirmarExcluir(comprometimento.idRateioComprometimento)"
        ></i>
    </span>
</template>

<script>
import ConveniosServicos from '../../ConveniosServicos'

export default {
    props: {
        convenio: Object,
        comprometimento: Object, 
    },

    methods: {
        confirmarExcluir(id){
            this.$swal({
                title: 'Excluir',
                html: 'Deseja Excluir o Comprometimento ?',
                icon: 'error',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.excluir(id)
                }
            })
        },

        excluir(id){
            this.$store.dispatch('addRequest')
            ConveniosServicos.excluirRateioComprometimento(id)
            .then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Comprometimento excluído com sucesso',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.$emit('atualizarListaComprometimentos')
                    }
                    else{
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },
    }
}
</script>
